import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import { IFilter } from "../../../../types/filter.type";
import FilterText from "../FilterText";

function FilterCRNsx({ filter, setFilter, load }: IFilter) {
  const defaultFilter = {
    nsx: "",
  };

  useEffect(() => {
    setFilter(defaultFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return (
    <Stack sx={{ width: "100%" }} gap={2}>
      <FilterText
        label="Nước sản xuất"
        placeholder="Tìm theo nước sản xuất"
        defaultValue={filter.nsx}
        onChange={(val) => setFilter({ ...filter, nsx: val })}
      />
    </Stack>
  );
}

export default FilterCRNsx;
